import React, { Component } from "react";
import MyTable from "../Components/Table";

class BureauIssue extends Component {
  render() {
    return <MyTable requestParams="queryAllWorkByPage" classify='教育局发文' />;
  }
}
export default BureauIssue;

